export default [
    {
        displayName: "FLAC",
        format: "flac",
        samples: 44100,
        resolution: 24,
        bitrate: 1411000,
        codec: "flac",
    },
    {
        displayName: "MP3 128kbs",
        format: "mp3",
        samples: 48000,
        resolution: 24,
        bitrate: 128000,
        codec: "libmp3lame",
    },
    {
        displayName: "MP3 192kbs",
        format: "mp3",
        samples: 48000,
        resolution: 24,
        bitrate: 192000,
        codec: "libmp3lame",
    },
    {
        displayName: "MP3 256kbs",
        format: "mp3",
        samples: 48000,
        resolution: 24,
        bitrate: 256000,
        codec: "libmp3lame",
    },
    {
        displayName: "MP3 320kbs",
        format: "mp3",
        samples: 48000,
        resolution: 24,
        bitrate: 320000,
        codec: "libmp3lame",
    },
    {
        displayName: "WAV PCM 48k/24Bit",
        format: "wav",
        samples: 48000,
        resolution: 24,
        codec: "pcm_s24le",
        bitrate: 2822000,
    },
    {
        displayName: "WAV PCM 44.1k/16Bit",
        format: "wav",
        samples: 44100,
        resolution: 16,
        codec: "pcm_s16le",
        bitrate: 1411000,
    },
];
